import * as types from '../actions/actionTypes';

const initialState = {
  cardInfo: {
    cardNumber: "", // ccNum
    cardName: "", // name
    expMonth: "",
    expYear: "",
    cvv: "",
    country: "USA",
    // zipCode: "",
    // country: defaultCountryValue,
  },
  cardErrors: {}, // {"cardName": ["too short"]}, {"phoneNumber": ["this field is required"]}, etc.
  shippingErrors: {}, // {"postal": ["too short"]}, {"phoneNumber": ["this field is required"]}, etc.
  selectedShippingAddressIndex: 0, // not used anymore, we can't select shipping addresses
  selectedBillingAddressIndex: 0, // not used anymore, we can't select shipping addresses
  shippingAddress: {
    fullName: "", // name
    address1: "",
    address2: "",
    city: "",
    state: "",
    stateShort: "", // used in google maps submit
    postal: "", // zip
    country: "" // zip
  },
  billingAddress: {
    fullName: "", // name
    address1: "",
    address2: "",
    city: "",
    state: "",
    stateShort: "", // used in google maps submit
    postal: "" // zip
  },
  billingSameAsShipping: false,
};

export default function(state = initialState, action){
  switch (action.type) {
    case types.SET_PAYMENT_INFO:
      return Object.assign({}, state, {
        [action.payload.name]: action.payload.value
      });
    case types.SET_SHIPPING_INFO:
      return Object.assign({}, state, {
        shippingAddress: {
          ...state.shippingAddress, ...{[action.payload.name]: action.payload.value}
        }
      });
    case types.SET_BILLING_INFO:
      return Object.assign({}, state, {
        billingAddress: {
          ...state.billingAddress, ...{[action.payload.name]: action.payload.value}
        }
      });
    case types.SET_CARD_INFO:
      return Object.assign({}, state, {
        cardInfo: {
          ...state.cardInfo, ...{[action.payload.name]: action.payload.value}
        }
      })
    case types.SET_CARD_ERRORS:
      return Object.assign({}, state, {
        cardErrors: {...state.cardErrors, ...action.payload.cardErrors}
      })
    case types.SET_SHIPPING_ERRORS:
      return Object.assign({}, state, {
        shippingErrors: {...state.shippingErrors, ...action.payload.shippingErrors}
      })
    case types.RESTORE_PAYMENT_INFO:
      return Object.assign({}, state, Object.assign({}, action.payload))
  }
  return state;
}
